{
  "Dashboard": "Dashboard",
  "BlyCareShippingProte": "Protezione spedizione BlyCare",
  "LoadingBlyCare": "Caricamento di BlyCare…",
  "LoadingWidgetSetting": "Caricamento impostazioni widget…",
  "PreparingYourWorkspa": "Preparazione dello spazio di lavoro",
  "Language": "Lingua",
  "English": "English",
  "EnglishDefault": "English (predefinito)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Guida alla configurazione",
  "CompletedOfTotalComp": "{{completed}} di {{total}} completati",
  "Dismiss": "Chiudi",
  "MoreActions": "Altre azioni",
  "ToggleSetupGuide": "Mostra/nascondi la guida alla configurazione",
  "ActivateAppEmbed": "Attiva app embed",
  "ClickTheEnableButton": "1. Fai clic sul pulsante Attiva qui sotto per aprire l'editor del tema di Shopify.",
  "BlyCareEmbedSection": "2. Cerca BlyCare nella sezione App embed a sinistra. Assicurati che l'interruttore sia attivo. Poi fai clic su Salva in alto a destra.",
  "Enable": "Attiva",
  "PublishWidget": "Pubblica widget",
  "PublishStorefront": "Pubblica il widget nella vetrina del negozio, così che i clienti possano acquistarlo.",
  "Publish": "Pubblica",
  "SetProtectionFee": "Imposta tariffa di protezione",
  "FeeYouWantToCharge": "Imposta la tariffa che vuoi applicare ai clienti.",
  "Setup": "Configura",
  "TestYourWidgetOnYour": "Prova il widget sul tuo negozio",
  "AddAProductToYourCar": "Aggiungi un prodotto al carrello e verifica che il widget di protezione spedizione venga visualizzato. Seleziona la protezione spedizione, poi continua verso il pagamento e assicurati che il prodotto di protezione spedizione sia incluso nella pagina di pagamento.",
  "TestNow": "Prova ora",
  "Working": "Funziona tutto",
  "NeedHelp": "Serve aiuto",
  "MarkAsCompleted": "Segna come completato",
  "AppStatus": "Stato dell'app",
  "AppEmbed": "App embed",
  "EnableAppEmbedToDisp": "Attiva app embed per visualizzare la protezione spedizione nel carrello.",
  "CartPage": "Visualizza la protezione spedizione nella pagina del carrello.",
  "CheckoutBlock": "Blocco di pagamento",
  "CheckoutPage": "Visualizza la protezione spedizione nella pagina di pagamento.",
  "Active": "Attivo",
  "Inactive": "Inattivo",
  "Analytics": "Analisi",
  "Today": "Oggi",
  "Last7Days": "Ultimi 7 giorni",
  "Last30Days": "Ultimi 30 giorni",
  "Last60Days": "Ultimi 60 giorni",
  "Last90Days": "Ultimi 90 giorni",
  "Last365Days": "Ultimi 365 giorni",
  "Custom": "Personalizzato",
  "Start": "Inizio",
  "End": "Fine",
  "DateRange": "Intervallo di date",
  "SelectedRange": "Intervallo selezionato: {{range}}",
  "Cancel": "Annulla",
  "Save": "Salva",
  "ChooseAStartDateOnOr": "Scegli una data di inizio uguale o precedente alla data di fine e non selezionare un giorno successivo a oggi.",
  "PreviousMonth": "Mese precedente",
  "NextMonth": "Mese successivo",
  "ProtectionRevenue": "Ricavi da protezione",
  "ProtectedOrders": "Ordini protetti",
  "ProtectedOrderRate": "Tasso di ordini protetti",
  "LoadingAnalytics": "Caricamento analisi…",
  "AnalyticsCouldNotLo": "Impossibile caricare le analisi",
  "RetryAnalytics": "Riprova analisi",
  "Resources": "Risorse",
  "HowDoesShippingProte": "Come funziona la protezione spedizione?",
  "BlyCareAddsAShipping": "BlyCare aggiunge un widget di protezione spedizione al carrello. I clienti possono scegliere di aggiungere la protezione ai propri ordini. Il commerciante riscuote la tariffa di protezione, decide quali situazioni sono coperte e utilizza tali tariffe per risolvere i reclami.",
  "DoesBlyCareCoverInsu": "BlyCare copre i sinistri assicurativi?",
  "NoBlyCareIsNotInsura": "No. BlyCare non è un'assicurazione e non paga sinistri. BlyCare fornisce solo il widget e gli strumenti per consentire ai commercianti di gestire il proprio programma di protezione spedizione.",
  "EmailUs": "Scrivici",
  "LiveChat": "Chat dal vivo",
  "HelpCenter": "Centro assistenza",
  "Settings": "Impostazioni",
  "CheckoutWidget": "Widget di pagamento",
  "CartWidget": "Widget del carrello",
  "PriceSetting": "Impostazione prezzo",
  "ProductSetting": "Impostazione prodotto",
  "AdminLanguage": "Lingua dell'amministratore",
  "AdminLanguageTitle": "Lingua dell'amministratore",
  "AdminLanguageHelp": "Cambia la lingua dell'app solo per te. I clienti non sono interessati.",
  "AppLanguage": "Lingua dell'app",
  "UnableToLoadSettings": "Impossibile caricare le impostazioni",
  "TryAgain": "Riprova",
  "Discard": "Scarta",
  "LoadingSettings": "Caricamento impostazioni",
  "PageNotFound": "Pagina non trovata",
  "ProductSettingsCould": "Impossibile salvare le impostazioni del prodotto.",
  "Fulfillment": "Evadizione",
  "FulfillmentHelp": "Scegli quando il prodotto di protezione viene contrassegnato come evaso.",
  "ManuallyFulfill": "Evadi manualmente",
  "MarkFulfilledWhenFir": "Contrassegna come evaso quando viene evaso il primo articolo dell'ordine",
  "MarkFulfilledWhenAll": "Contrassegna come evaso quando vengono evasi tutti gli altri articoli dell'ordine",
  "MarkFulfilledImmedi": "Contrassegna come evaso subito dopo la creazione dell'ordine",
  "Exclusions": "Esclusioni",
  "ExclusionsHelp": "Scegli quando la protezione non deve essere applicata.",
  "ExclusionType": "Tipo di esclusione",
  "Select": "Seleziona",
  "SelectedExclusions": "Esclusioni selezionate",
  "RemoveName": "Rimuovi {{name}}",
  "WhenExcluded": "In caso di esclusione",
  "HideWidget": "Nascondi widget",
  "KeepWidgetButSkipThe": "Mantieni il widget ma ometti la tariffa",
  "ExcludeProductType": "Escludi tipo di prodotto",
  "SearchProductType": "Cerca tipo di prodotto",
  "ExcludeSKU": "Escludi SKU",
  "SearchSKU": "Cerca SKU",
  "ExcludeCollection": "Escludi collezione",
  "SearchCollection": "Cerca collezione",
  "ExcludeMarket": "Escludi mercato",
  "SearchMarket": "Cerca mercato",
  "ExcludeLanguage": "Escludi lingua",
  "SearchLanguage": "Cerca lingua",
  "Add": "Aggiungi",
  "PriceSettingsCouldNo": "Impossibile salvare le impostazioni dei prezzi.",
  "ShippingProtectionPr": "Prezzo della protezione spedizione",
  "SetHowMuchPriceDoYou": "Imposta quanto addebitare al cliente",
  "PricingMethod": "Metodo di prezzo",
  "Fixed": "Fisso",
  "Percentage": "Percentuale",
  "UniversalProtectionP": "Prezzo di protezione universale",
  "PercentageOfCartSubt": "Percentuale del subtotale del carrello",
  "EditCappedPrice": "Modifica prezzo massimo",
  "ShippingProtectionFe": "Tariffa di protezione spedizione in percentuale, a partire da {{minPrice}} USD, con incrementi di {{increment}} USD, fino a un massimo di {{capped}} USD.",
  "MinProtectionFee": "Tariffa di protezione minima",
  "IncrementAmount": "Importo incremento",
  "CappedProtectionFee": "Tariffa di protezione massima",
  "AddTierPrice": "Aggiungi prezzo a scaglioni",
  "AddTier": "Aggiungi scaglione",
  "TierPriceHelp": "Se il prezzo del carrello non rientra in nessun intervallo di prezzi a scaglioni, verrà applicato il prezzo universale impostato nella pagina precedente.",
  "MinCartPrice": "Prezzo minimo del carrello",
  "MaxCartPrice": "Prezzo massimo del carrello",
  "ProtectionFee": "Tariffa di protezione",
  "RemoveTier": "Rimuovi scaglione",
  "Required": "Obbligatorio",
  "ThisFieldIsRequired": "Questo campo è obbligatorio.",
  "MustBeGreaterThanZero": "{{label}} deve essere maggiore di 0.",
  "MustBeOrLess": "{{label}} deve essere pari o inferiore a {{max}}.",
  "AtMostTwoDecimals": "{{label}} può avere al massimo 2 decimali.",
  "MustBeLargerThanMinC": "Deve essere maggiore del prezzo minimo del carrello",
  "MustBeLargerThanMaxC": "Deve essere maggiore del prezzo massimo del carrello",
  "MustBeSmallerThanMin": "Deve essere minore del prezzo minimo del carrello",
  "Price": "Prezzo",
  "MinimumPrice": "Prezzo minimo",
  "Increment": "Incremento",
  "CartPageWidget": "Widget pagina carrello",
  "CheckoutPageWidget": "Widget pagina di pagamento",
  "WidgetFormat": "Formato widget",
  "TickerWidget": "Widget standard",
  "CheckoutButtonWidget": "Widget pulsante di pagamento",
  "Text": "Testo",
  "MainText": "Testo principale",
  "Title": "Titolo",
  "Description": "Descrizione",
  "MainButtonText": "Testo del pulsante principale",
  "SecondaryButtonText": "Testo del pulsante secondario",
  "EnabledDescription": "Descrizione attiva",
  "DisabledDescription": "Descrizione disattivata",
  "PleaseEnterTitle": "Inserisci il titolo",
  "PleaseEnterDescript": "Inserisci la descrizione",
  "PleaseEnterMainButt": "Inserisci il testo del pulsante principale",
  "PleaseEnterSecondar": "Inserisci il testo del pulsante secondario",
  "PleaseEnterEnabledD": "Inserisci la descrizione attiva",
  "PleaseEnterDisabled": "Inserisci la descrizione disattivata",
  "EGViewTerms": "es. Visualizza i termini",
  "EGHttpTerms": "es. https://terms.com",
  "Footer": "Piè di pagina",
  "FooterText": "Testo del piè di pagina",
  "FooterLink": "Link del piè di pagina",
  "TooltipLink": "Link del tooltip",
  "FooterVisibility": "Visibilità del piè di pagina",
  "TitleInfoVisibility": "Visibilità delle informazioni del titolo",
  "Disabled": "Disattivato",
  "Enabled": "Attivato",
  "Color": "Colore",
  "ColorStyle": "Stile colore",
  "SizeAndDisplay": "Dimensioni e visualizzazione",
  "IconSize": "Dimensione icona",
  "IconRadius": "Raggio icona",
  "BorderSize": "Dimensione bordo",
  "BorderRadius": "Raggio bordo",
  "HorizontalPadding": "Padding orizzontale",
  "VerticalPadding": "Padding verticale",
  "ToggleFormat": "Formato interruttore",
  "Switch": "Interruttore",
  "Checkbox": "Casella di controllo",
  "Border": "Bordo",
  "Background": "Sfondo",
  "ProtectionDescript": "Descrizione della protezione",
  "MainButtonBackgrou": "Sfondo del pulsante principale",
  "EnabledToggle": "Interruttore attivo",
  "DisabledToggle": "Interruttore disattivato",
  "Automatic": "Automatico",
  "Neutral": "Neutro",
  "Info": "Informazioni",
  "Success": "Successo",
  "Warning": "Avviso",
  "Critical": "Critico",
  "Subdued": "Attenuato",
  "Transparent": "Trasparente",
  "ThemeColor": "Colore del tema",
  "ResetToDefaultColor": "{{label}}: ripristina il colore predefinito",
  "OpenColorPicker": "{{label}}: apri selettore colore",
  "Icon": "Icona",
  "PackageIcon": "Icona pacco",
  "PackageIconNumber": "Icona pacco {{value}}",
  "UploadIcon": "Carica icona",
  "NoIcon": "Nessuna icona",
  "AcceptedFormats": "Formati accettati: PNG, JPG, SVG",
  "MaximumFileSize": "Dimensione massima del file: 50 MB",
  "AddFiles": "Aggiungi file",
  "RemoveImage": "Rimuovi immagine",
  "Uploading": "Caricamento in corso",
  "UploadFailedTryAgain": "Caricamento non riuscito. Riprova.",
  "ChooseAJPEGPNG": "Scegli un'immagine JPEG, PNG o SVG fino a 50 MB.",
  "ChooseNonemptyImage": "Scegli un'immagine JPEG, JPG, PNG o SVG non vuota fino a 50 MB.",
  "ImageCouldNotBeRead": "Impossibile leggere l'immagine.",
  "FileContentsMismatch": "Il contenuto del file deve corrispondere al tipo di immagine JPEG, PNG o SVG.",
  "ImageCouldNotBeDecode": "Impossibile decodificare l'immagine.",
  "InvalidImageUrl": "Il servizio di caricamento ha restituito un URL immagine non valido.",
  "MissingPublicImageUrl": "Il servizio di caricamento non ha restituito un URL immagine pubblico.",
  "CustomCssTooLong": "Il CSS personalizzato può contenere al massimo 2.000 caratteri.",
  "ChooseValidIconUrl": "Scegli un'icona caricata con un URL valido.",
  "EnterNumberRange": "Inserisci un numero da {{min}} a {{max}}.",
  "EnterLocaleTextRange": "Inserisci il testo {{locale}} tra 1 e {{limit}} caratteri.",
  "EnterValidLearnMoreUrl": "Inserisci un URL valido per Scopri di più che inizi con https:// o http://.",
  "ReviewHighlightedFields": "Controlla i campi evidenziati.",
  "CannotChangePublishState": "Impossibile modificare lo stato di pubblicazione finché il modulo non è valido: {{reason}}",
  "BlyCareCouldNotSave": "Impossibile salvare con BlyCare.",
  "CheckoutRequiresPlus": "La personalizzazione del pagamento richiede Shopify Plus.",
  "SaveSucceededReloadFailed": "La richiesta di salvataggio è riuscita, ma non è stato possibile caricare le impostazioni più recenti del widget. Aggiorna la pagina per verificare le modifiche.",
  "BlyCareCouldNotComplete": "BlyCare non è riuscito a completare questa richiesta.",
  "ShopifyAuthorizationRequired": "È necessaria l'autorizzazione di Shopify.",
  "AppBridgeUnavailable": "Shopify App Bridge non è disponibile",
  "ExtensionStatusUnavailable": "Lo stato dell'estensione Shopify non è disponibile.",
  "ConfigurationPreview": "Anteprima configurazione",
  "On": "Attivo",
  "Off": "Disattivato",
  "Unpublish": "Annulla pubblicazione",
  "AppEmbedIsNotEnable": "L'app embed non è attivata.",
  "GoEnabled": "Vai a Attiva",
  "ViewOnYourStorefront": "Visualizza nella vetrina",
  "PreviewProtection": "Anteprima protezione",
  "MoreInformation": "Maggiori informazioni",
  "Cart": "Carrello",
  "Subtotal": "Subtotale",
  "Checkout": "Pagamento",
  "DiscountCode": "Codice sconto",
  "Apply": "Applica",
  "Shipping": "Spedizione",
  "Total": "Totale",
  "ShippingProtection": "Protezione spedizione",
  "Product": "Prodotto",
  "CopyLink": "Copia link"
}
